module.exports = __webpack_public_path__ + "img/jinjiang.0697d9ec.jpg";